<!--
    描述：编码规则管理页面
    时间：2020-04-29
    Created by yefan
-->
<template>
	<div class="w-page-main">
		<!-- 顶部搜索栏 -->
		<div class="w-page-header">
			<search-area ref="searchContent"
						 v-model="searchForm.tag"
						 placeholderName="规则类型"
						 @on-search="onSearch"
						 @on-refresh="onRefresh"
						 @on-reset="onReset">
				<el-form slot="searchform"
						 :model="searchForm"
						 label-width="90px">
					<el-form-item label="适用单位">
						<el-input placeholder="请输入适用单位名称"
								  v-model="searchForm.company"></el-input>
					</el-form-item>
					<el-form-item label="启用日期">
						<el-date-picker v-model="searchForm.startDate"
										type="date"
										placeholder="请选择启用日期"
										value-format="yyyy-MM-dd"></el-date-picker>
					</el-form-item>
				</el-form>
			</search-area>
			<div class="btnGroups ml10">
				<el-button type="primary"
						   size="small"
						   @click="addClick">新增编码规则</el-button>
			</div>
		</div>
        
		<!-- 下方内容 -->
		<div class="w-page-container">
			<code-list ref="codeList"
					   :searchObj="searchForm"></code-list>
		</div>
	</div>
</template>

<script>
import searchArea from '@/components/searchArea/searchArea'
import codeList from './components/code_list'

export default {
	components: { searchArea, codeList },
	data() {
		return {
			searchForm: {
				tag: '',
				company: '',
				startDate: ''
			}
		}
	},
	methods: {
		addClick() {
			this.$refs.codeList.doClick()
		},

		// 确认搜索
		onSearch() {
			this.$refs.codeList.getTablePageList()
		},

		// 点击刷新
		onRefresh() {
			this.onReset()
			this.onSearch()
		},

		// 点击重置
		onReset() {
			this.searchForm.tag = ''
			this.searchForm.startDate = null
			this.searchForm.company = ''
		}
	}
}
</script>